module.exports = __webpack_public_path__ + "img/skywind.97018404.jpg";